import { IContentSearchQuery, SearchRepository } from '../repositories/SearchRepository';

export class SearchContentLoadedUseCase {
    private searchRepository: SearchRepository;
    private contentSearchQuery: IContentSearchQuery;

    constructor(searchRepository: SearchRepository, contentSearchQuery: IContentSearchQuery) {
        this.searchRepository = searchRepository;
        this.contentSearchQuery = contentSearchQuery;
    }

    public execute = async () => {
        await this.searchRepository.getContentSearchResults(this.contentSearchQuery);
    };
}
